<template>
  <div>
    <div
      v-if="!inline"
      class="row q-col-gutter-sm"
    >
      <div class="text-h6">
        Filtres
      </div>
    </div>
    <div class="row q-col-gutter-sm">
      <div
        v-for="filter in filterList"
        :key="filter.key"
        :class="inline ? 'col' : col"
      >
        <component
          :is="filter.component.name"
          v-if="filter.component"
          v-model="vValue[filter.key]"
          :label="filter.label"
          v-bind="filter.props"
        />
        <lwf-autocomplete
          v-else
          v-model="value[filter.key]"
          :label="filter.label"
          v-bind="filter.props"
          clearable
        />
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import AutocompleteSite from 'components/fields/AutocompleteSite'
import LwfDatePicker from 'components/core/LwfDatePicker'
import LwfDateRangePicker from 'components/core/LwfDateRangePicker'
import AutocompleteSpecialite from 'components/fields/AutocompleteSpecialite'
import autoDefaultModelMixin from '@/mixins/autoDefaultModelMixin'
import AutocompleteTypeMc from 'components/fields/AutocompleteTypeMc'
import SelectExpirationType from 'components/Select/SelectExpirationType'
import SelectCustomerType from 'components/Select/SelectCustomerType'
import SelectAgentType from 'components/Select/SelectAgentType'
import SelectUnavailabilityType from 'components/Select/SelectUnavailabilityType'
import { availableFilters, defaultSelectProps } from '@/utils/filters'
import { devLog } from '@/utils'
import AutocompleteAgent from 'components/fields/AutocompleteAgent'
import AutocompleteClient from 'components/fields/AutocompleteClient'
import AutocompleteAgency from 'components/fields/AutocompleteAgency'

const storeUserAgency = createNamespacedHelpers('user/agency')

export default {
  name: 'LwfFormFilters',
  components: {
    LwfAutocomplete,
    AutocompleteSite,
    AutocompleteClient,
    AutocompleteSpecialite,
    AutocompleteAgency,
    LwfDatePicker,
    LwfDateRangePicker,
    AutocompleteAgent,
    AutocompleteTypeMc,
    SelectCustomerType,
    SelectAgentType,
    SelectUnavailabilityType,
    SelectExpirationType
  },
  mixins: [autoDefaultModelMixin],
  props: {
    value: {
      type: [Object, Function],
      default: _.stubObject
    },
    filters: {
      type: Array,
      default: () => (['agents', 'sites', 'customers'])
    },
    inline: Boolean,
    col: {
      type: String,
      default: 'col-6'
    }
  },
  computed: {
    ...storeUserAgency.mapGetters({
      agents: 'agents'
    }),
    ...storeUserAgency.mapState({
      clients: 'clients'
    }),
    filterList () {
      return this.filters.map((f) => {
        if (typeof f === 'string') {
          const filter = availableFilters[f]
          if (!filter) {
            devLog('error', `Le filtre ${f} n'existe pas`)
            return null
          }
          return this._filterEntry(filter.key || f, filter)
        }
        const { type, key, ...filter } = f
        if (type && availableFilters[type]) {
          const _filter = availableFilters[type]
          if (!_filter) throw new Error(`Le filtre ${type} n'existe pas`)
          return this._filterEntry(key || _filter.key || type, _.merge({}, availableFilters[type], filter))
        }
        return this._filterEntry(f.key, filter)
      }).filter((f) => f)
    },
    vValue () {
      return (typeof this.value === 'function') ? this.value() : this.value
    }
  },
  methods: {
    _isAllFilter (k) {
      return this.value[k] === undefined || (Array.isArray(this.value[k]) && this.value[k].length === 0)
    },
    _filterEntry (f, filter) {
      const props = (filter.props || {})
      const options = typeof props.options === 'function'
        ? props.options(this)
        : props.options
      const label = filter.label || ''

      const computedProps = {}
      // Hint
      const allLabel = filter.allLabel || 'Tous'
      computedProps.hint = this._isAllFilter(f)
        ? `${allLabel} les ${label.toLowerCase()}`
        : ''
      // Counter
      if (filter.counter) {
        const l = (this.value[f] || []).length
        computedProps.displayValue = l ? `${l} ${label.toLowerCase()}` : ''
      }
      return {
        label,
        ...filter,
        key: f,
        props: {
          dense: true,
          ...defaultSelectProps,
          ...computedProps,
          ...(filter.props || {}),
          options
        }
      }
    }
  }
}
</script>
